"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section } from "@/src/components";
import { DateRangePickerBlock } from "@/src/components/input/date-range-picker";

export default function DocsBlocksDateRangePicker() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Date Range Picker
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A date picker that allows selecting a range of dates with start and end date selection.
          </Text>
        </div>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Select a date range</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <DateRangePickerBlock
            label="Date Range"
            onChange={(value) => console.log("Selected:", value)}
          />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">value</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">DateRange</td>
                <td className="py-2 text-muted-foreground">Selected date range (from/to)</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">onChange</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">(range: DateRange) =&gt; void</td>
                <td className="py-2 text-muted-foreground">Change handler</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">label</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Input label</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">placeholder</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Placeholder text</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
